var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-checkbox-group" }, [
    _c("span", { staticClass: "c-checkbox-group__label" }, [
      _vm._v(_vm._s(_vm.filters.label))
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "c-checkbox-group__list" },
      _vm._l(_vm.filters.options, function(item, index) {
        return _c(
          "li",
          { key: item.id, staticClass: "c-checkbox-group__list-item" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkedNames,
                  expression: "checkedNames"
                }
              ],
              staticClass: "c-checkbox-group__list-input visually-hidden",
              attrs: { id: index, type: "checkbox" },
              domProps: {
                value: item.value,
                checked: Array.isArray(_vm.checkedNames)
                  ? _vm._i(_vm.checkedNames, item.value) > -1
                  : _vm.checkedNames
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.checkedNames,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = item.value,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.checkedNames = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.checkedNames = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.checkedNames = $$c
                    }
                  },
                  _vm.updateValue
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "c-checkbox-group__list-label",
                attrs: { for: index }
              },
              [_vm._v(_vm._s(item.label))]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27a21200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a21200","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/entrade/community-search-results/checkbox.vue
// module id = 506
// module chunks = 0